import StickerCompanyTable from './StickerCompanyTable';

export default StickerCompanyTable;
